import { render } from "./DsPolicyDomainSkeleton.vue?vue&type=template&id=834de8f0"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__